export const BASE_PRICE_ADJUSTMENTS_SIDEBAR = 'basePriceAdjustmentSidebar';

export const BASE_PRICE_FORM = 'basePriceForm';
export const DEPENDENT_RATE_ADJUSTMENT_FORM = 'dependentRateAdjustmentForm';
export const OCCUPANCY_ADJUSTMENT_FORM = 'occupancyAdjustmentForm';
export const AGE_CATEGORY_ADJUSTMENT_FORM = 'ageCategoryAdjustmentForm';

export const RATE_ADJUSTMENT_FORM = 'rateAdjustmentForm';
export const ATTRIBUTE_PRICE_ADJUSTMENT_FORM = 'attributePriceAdjustmentForm';
export const RATE_MANAGEMENT_FILTER_FORM = 'rateManagementFilterForm';

export const HEADER_HEIGHT = 66;
export const CELL_HEIGHT = 56;
export const CELL_WIDTH = 128;

export const BASE_PRICE_ROW_INDEX = '1';

export const PERCENTAGE_PRECISION = 2;

export const HIDE_SYMBOL_OPTION = { showSymbol: false };

export const MAX_NUMBER_VALUE = 10000000000000;
